/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/information'
export default icon
